import { useState } from "react";
import {AiOutlinePlus, AiOutlineUpload} from "react-icons/ai";
import CreateVehicle from "./CreateVehicle";
import UploadVehicle from "./UploadVehicle";

const UploadWrapper = ({ refetch }: any) => {
  const [uploadModal, setUploadModal] = useState(false);

  const handleShowModal = () => {
      setUploadModal(true);
  };

  const handleHideModal = () => {
      setUploadModal(false);
  };

  return (
    <>
      <button
        onClick={() => handleShowModal()}
        className="border rounded-md px-2 py-1 flex items-center mr-4"
      >
        <AiOutlineUpload />
        <span className="ml-2">Upload</span>
      </button>
      <UploadVehicle
        isVisible={uploadModal}
        hideModal={handleHideModal}
      />
    </>
  );
};

export default UploadWrapper;
